import React from "react";
import { ServiceNotice } from "../types";
import { getCreateStepMessage } from "../utils";
import { useTranslation } from "react-i18next";

interface Props {
  percent: number;
  notice: ServiceNotice | "";
  onClose: () => void;
}

const CreateProgressBanner = ({ percent, notice, onClose }: Props) => {
  const { t } = useTranslation();
  const isDone = notice === "SERVICE";
  const message = getCreateStepMessage(notice, t);

  return (
    <div className={isDone ? "installDone" : "installProgress"}>
      <div className="name">
        {isDone && (
          <span className="text text--green">
            <i className="icon_circle_check vertical-middle mg mr-10 mb-2" />
            {getCreateStepMessage("SERVICE", t)}
          </span>
        )}
        {!isDone && <span>{message}</span>}
      </div>

      {isDone ? (
        <p className="closeBtn" onClick={onClose}>
          {t("common.close")}
        </p>
      ) : (
        <div className="progress progress__chart">
          <div
            className="progress-bar"
            style={{ width: `${Math.min(100, Math.max(0, percent))}%` }}
          />
        </div>
      )}
    </div>
  );
};

export default CreateProgressBanner;
